import {
  faCubes,
  faChartLine,
  faPollH,
  faTasks,
  faEye,
  faUsers,
  faHandshakeAlt,
  faAt,
  faBookSpells,
  faNewspaper,
  faBlog,
  faUserHardHat,
  faCar,
  faShoppingCart,
  faLockAlt,
  faQuestion,
  faShieldCheck,
  // faFileInvoiceDollar,
  faUserGraduate,
  faGamepadAlt,
  faCube,
  faBook,
  faBooks,
  faPaperPlane,
} from '@fortawesome/pro-duotone-svg-icons'

export const SITE_LINKS = {
  company: {
    About: {
      title: 'About',
      href: '/about/',
      icon: faEye,
      iconColor: '#2D3748',
      iconBackgroundColor: 'transparent',
    },
    Careers: {
      title: 'Careers',
      href: 'https://www.linkedin.com/company/cognitive3d/jobs/',
      icon: faUsers,
      iconColor: '#2D3748',
      iconBackgroundColor: 'transparent',
    },
    Resources: {
      title: 'Case Studies & Resources',
      href: '/resources/',
      icon: faBooks,
      iconColor: '#ffffff',
      iconBackgroundColor: '#ad5dc3',
      backgroundColor: '#EDF2F7',
    },
    ProductRoadmap: {
      title: 'Product Roadmap',
      href: 'https://roadmap.cognitive3d.com/board',
      icon: faPaperPlane,
      iconColor: '#2D3748',
      iconBackgroundColor: 'transparent',
    },
    PartnerPrograms: {
      title: 'Partner Programs',
      href: '/partner-programs/',
      icon: faHandshakeAlt,
      iconColor: '#2D3748',
      iconBackgroundColor: 'transparent',
    },
    Contact: {
      title: 'Contact',
      href: '/contact/',
      icon: faAt,
      iconColor: '#2D3748',
      iconBackgroundColor: 'transparent',
    },
    PressKit: {
      title: 'Press Kit',
      href: '/press-kit/',
      icon: faNewspaper,
      iconColor: '#2D3748',
      iconBackgroundColor: 'transparent',
    },
    CaseStudies: {
      title: 'Case Studies',
      href: '/case-studies/',
      icon: faBookSpells,
      iconColor: '#2D3748',
      iconBackgroundColor: 'transparent',
    },
    Blog: {
      title: 'Blog',
      href: '/blog/',
      icon: faBlog,
      iconColor: '#2D3748',
      iconBackgroundColor: 'transparent',
      backgroundColor: '#EDF2F7',
      className: 'blog',
    },
    PrivacyPolicy: { title: 'Privacy Policy', href: '/privacy-policy/' },
  },
  product: {
    ObjectExplorer: {
      title: 'Dynamic Objects',
      href: '/product/objectexplorer/',
      description: 'Get insight into 3D object engagement',
      icon: faCubes,
      iconColor: '#ffffff',
      iconBackgroundColor: '#652FCB',
    },
    SceneExplorer: {
      title: 'SceneExplorer',
      href: '/product/scene-explorer/',
      icon: faEye,
      description: 'Review 1:1 session replays instantly in 3D',
      iconColor: '#ffffff',
      iconBackgroundColor: '#13D063',
    },
    SceneViewer: {
      title: 'Scene Viewer',
      href: '/product/scene-viewer/',
      icon: faCube,
      description: 'Aggregate metrics on a 3D dollhouse of your scene',
      iconColor: '#ffffff',
      iconBackgroundColor: '#fda83b',
    },
    Dashboard: {
      title: 'Analytics',
      href: '/product/dashboard/',
      icon: faChartLine,
      description: 'Analyze data gathered from VR/AR',
      iconColor: '#ffffff',
      iconBackgroundColor: '#4A5568',
    },
    Objectives: {
      title: 'Objectives',
      href: '/product/objectives/',
      description: 'Define and measure success from 3D simulation',
      icon: faTasks,
      iconColor: '#ffffff',
      iconBackgroundColor: '#1FA4F2',
    },
    TermsOfService: { title: 'Terms of Service', href: '/terms-of-service/' },
    ExitPoll: {
      title: 'ExitPoll',
      href: '/product/exitpoll/',
      description: 'Collect survey results and identify painpoints',
      icon: faPollH,
      iconColor: '#ffffff',
      iconBackgroundColor: '#4A1CA3',
    },
    SupportedEngines: {
      title: 'Supported Engines',
      backgroundColor: '#EDF2F7',
    },
    Unity: {
      title: 'Unity',
      href: '/product/unity/',
      description: 'Spatial Analytics for the Unity Engine',
      icon: 'unityLogo',
      backgroundColor: '#EDF2F7',
      iconImageSharp: true,
    },
    Unreal: {
      title: 'Unreal',
      href: '/product/unreal-analytics/',
      description: 'Spatial Analytics for the Unreal Engine',
      icon: 'unrealLogo',
      backgroundColor: '#EDF2F7',
      iconImageSharp: true,
    },
  },
  solution: {
    Training: {
      title: 'Training Simulation',
      href: '/training/',
      icon: faUserHardHat,
      iconColor: '#ffffff',
      iconBackgroundColor: '#1FA4F2',
    },
    Retail: {
      title: 'Consumer Research',
      href: '/retail/',
      icon: faShoppingCart,
      iconColor: '#ffffff',
      iconBackgroundColor: '#18BC5E',
    },
    Academic: {
      title: 'Academic Research',
      href: '/academic/',

      icon: faUserGraduate,
      iconColor: '#ffffff',
      iconBackgroundColor: '#fda83b',
    },
    Games: {
      title: 'Games & Entertainment',
      href: '/games/',

      icon: faGamepadAlt,
      iconColor: '#ffffff',
      iconBackgroundColor: '#42268E',
    },
    Automotive: {
      title: 'Automotive',
      href: '/automotive/',
      icon: faCar,
      iconColor: '#ffffff',
      iconBackgroundColor: '#C4C4C4',
    },
    WhyCognitive3D: {
      title: 'Why Cognitive3D',
      href: '/why-cognitive3d/',
      icon: faQuestion,
      iconColor: '#2D3748',
      iconBackgroundColor: 'transparent',
      backgroundColor: '#EDF2F7',
    },
    Enterprise: {
      title: 'Enterprise Ready',
      href: '/enterprise/',
      icon: faShieldCheck,
      iconColor: '#ffffff',
      iconBackgroundColor: '#3490fc',
      backgroundColor: '#EDF2F7',
    },
    // Licensing: {
    //   title: "Pricing",
    //   href: "/pricing/",
    //   icon: faFileInvoiceDollar,
    //   iconColor: "#2D3748",
    //   iconBackgroundColor: "transparent",
    //   backgroundColor: "#EDF2F7",
    // },

    DataSecurity: {
      title: 'Data & Security',
      href: '/data-security/',
      icon: faLockAlt,
      iconColor: '#2D3748',
      iconBackgroundColor: 'transparent',
      backgroundColor: '#EDF2F7',
    },
  },
  docs: {
    Docs: {
      title: 'Docs',
      href: 'https://docs.cognitive3d.com/',
      icon: faBook,
      iconColor: '#ffffff',
      iconBackgroundColor: '#1FA4F2',
    },
  },
}
